
const industries = [
  { name: 'Compliance & Security Consulting', icon: 'ri-shield-check-line' },
  { name: 'Fractional CFO / RevOps / Executive Advisory', icon: 'ri-line-chart-line' },
  { name: 'Implant & Full-Arch Dentistry', icon: 'ri-heart-pulse-line' },
  { name: 'Plastic Surgery & Aesthetic Medicine', icon: 'ri-stethoscope-line' },
  { name: 'Orthodontics & Clear Aligners', icon: 'ri-tooth-line' },
  { name: 'Estate Planning & Business Law Retainers', icon: 'ri-scales-3-line' },
  { name: 'Commercial HVAC & Infrastructure Services', icon: 'ri-building-line' },
  { name: 'Fertility / IVF Clinics', icon: 'ri-hospital-line' },
  { name: 'Wealth Management Firms', icon: 'ri-money-dollar-circle-line' },
  { name: 'Weight Loss & Metabolic Clinics', icon: 'ri-heart-add-line' },
  { name: 'Local Government & Municipal Operations', icon: 'ri-government-line' },
  { name: 'Multi-Location Medical Practices', icon: 'ri-map-pin-line' },
];

export default function IndustriesSection() {
  return (
    <section id="industries" className="bg-[#F7F9FC] py-32">
      <div className="max-w-[1280px] mx-auto px-8 lg:px-20">
        <div className="flex items-start gap-16 mb-20">
          <div className="flex-1">
            <h2 className="text-[44px] font-semibold text-[#0B1F3A] mb-5 leading-tight">
              Built for industries where precision matters.
            </h2>
            <p className="text-lg text-[#0B1F3A]/65 leading-relaxed max-w-[520px]">
              We specialize in environments where compliance, reputation, and revenue performance cannot be compromised.
            </p>
          </div>
          <div className="w-[340px] h-[220px] rounded-xl overflow-hidden flex-shrink-0 mt-2">
            <img
              src="https://public.readdy.ai/ai/img_res/e631a9735ada3a6c50a6c851ae2a1f65.jpg"
              alt="Professional business environment"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-5 mb-16">
          {industries.map((item, index) => (
            <div
              key={index}
              className="bg-white border border-[#0B1F3A]/8 rounded-lg p-6 hover:border-[#1EB6B0]/40 hover:shadow-md hover:-translate-y-0.5 transition-all cursor-pointer flex items-start gap-4"
            >
              <div className="w-10 h-10 rounded-lg bg-[#1EB6B0]/10 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg text-[#1EB6B0]`}></i>
              </div>
              <h3 className="text-[15px] font-medium text-[#0B1F3A] leading-snug pt-2">
                {item.name}
              </h3>
            </div>
          ))}
        </div>

        <p className="text-lg text-[#0B1F3A]/55 max-w-[700px]">
          If your organization operates under scrutiny, regulation, or financial accountability — we build systems that support scale without risk.
        </p>
      </div>
    </section>
  );
}
